import { render } from "./UsersForRoleView.vue?vue&type=template&id=39ce8b41&scoped=true&ts=true"
import script from "./UsersForRoleView.vue?vue&type=script&lang=ts"
export * from "./UsersForRoleView.vue?vue&type=script&lang=ts"

import "./UsersForRoleView.vue?vue&type=style&index=0&id=39ce8b41&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39ce8b41"]])

export default __exports__